import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import { cityParser } from '@/plugins/city_parser'
import Loading from '@/components/loading/loading'
import CashbackTooltip from '@/components/cashbackTooltip/cashbackTooltip'
import { isAlreadyBought } from '@/plugins/products_helper'
import { localCurrency } from '@/plugins/currency'

@Component({
  components: {
    Loading,
    CashbackTooltip
  }
})
export default class Cart extends Vue {
  @Getter getCountry: any
  @Getter getCart: any
  @Getter getCity: any
  @Getter getFreeProducts: any
  @Getter getIsToken: any

  @Action action_addCartProducts: any
  @Action action_removeCartProducts: any
  @Action action_getCurrentProduct: any

  @Mutation OPEN_CART: any

  isLoading = false;

  get isMiniMobile() {
    let miniMediaQuery = window.matchMedia("(max-width: 350px)");
    return miniMediaQuery.matches;
  }

  get getCartProducts() {
    const comparationFunction = (a, b) => {
      if(a.name && b.name) {
        if(a.name > b.name) {
          return 1;
        } else if(a.name < b.name) {
          return -1;
        } else {
          return 0;
        }
      }
    }
    if(this.getCart && this.getCart.cart_products) {
      return this.getCart.cart_products.sort(comparationFunction);
    }
    return [];
  }

  hasExceededMaxPromoQuantity(item) {
    let response = false;
    if(item && item.promo && item.promo.max_promos_per_cart && item.quantity_total) {
      const maxPromos = item.promo.max_promos_per_cart;
      const quantityTotal = item.quantity_total;
      if(quantityTotal > maxPromos) {
        response = true;
      }
    }
    return response;
  }

  showBasePrice(item) {
    let response = false;
    if(item && item.quantity_product_coupon_free && item.quantity_product) {
      response = true;
    }
    if(item && item.quantity_product_discount && item.quantity_product) {
      response = true;
    }
    return response;
  }

  getProductFreePrice(item) {
    let response = 0;
    if(item && item.price_coupon_free) {
      response = item.price_coupon_free;
    }
    return this.localCurrencyFormat(response);
  }

  getProductDiscountedPrice(item) {
    let response = 0;
    if(item && item.price_discount) {
      response = item.price_discount;
    }
    return this.localCurrencyFormat(response);
  }

  getProductBasePrice(item) {
    let response = 0;
    if(item && item.base_price) {
      response = item.base_price;
    }
    return this.localCurrencyFormat(response);
  }

  getProductDiscount(item) {
    if(item.discount) {
      const parsedDiscount = parseFloat(item.discount);
      return parsedDiscount;
    }
    return 0;
  }

  isFreeProduct(product) {
    let response = false;
    if(product && product.quantity_product_coupon_free > 0) {
      response = true;
    }
    return response;
  }

  freeProductLabel(product) {
    if(product.quantity_product_coupon_free > 0 && product.price_coupon_free >= 0) {
      const freePrice = this.localCurrencyFormat(product.price_coupon_free);
      return `${product.quantity_product_coupon_free} unidad(es) con valor ${freePrice}`;
    }
    return "";
  }

  _productsTotal (item) {
    let response = 0;
    if (item && item.price_total_sum) {
      response = parseFloat(item.price_total_sum);
    }
    return this.localCurrencyFormat(response);
  }

  private localCurrencyFormat(value) {
    let response = value;
    if(this.getCountry && this.getCountry.currency) {
      response = localCurrency(value);
    }
    return response;
  }

  _onShowCashbackMessage() {
    this.$emit('show-cashback');
  }

  _isAlreadyBought(item) {
    let response = false;
    if(item && item.product_id) {
      response = isAlreadyBought(item.product_id);
    }
    return response;
  }

  isAbleToRemove(item) {
    let response = true;
    if(item && item.quantity_total >= 0 && item.quantity_product_coupon_free >= 0) {
      const total = item.quantity_total;
      const free = item.quantity_product_coupon_free;
      return total > free;
    }
    return response;
  }

  _productsTotalDiscount(item) {
    let response = 0;
    if(item && item.price_discount_sum) {
      response = parseFloat(item.price_discount_sum);
    }
    return this.localCurrencyFormat(response);
  }

  async _add (item) {
    this.isLoading = true;
    try {
      if(item.product_id) {
        const requestObject = {
          products: [
            {
              product_id: item.product_id,
              qty: 1
            }
          ]
        }
        await this.action_addCartProducts(requestObject);
      }
    } catch (error) {
      if(error.data && error.data.message) {
        this.$swal({
          title: "Error",
          text: "¡Ups! Hubo un error de nuestra parte. Por favor inténtalo de nuevo."
        })
      }
    }
    this.isLoading = false;
  }

  async _remove (item) {
    this.isLoading = true;
    try {
      if(item.product_id && this.isAbleToRemove(item)) {
        const requestObject = {
          products: [
            {
              product_id: item.product_id,
              qty: 1,
              type: "remove"
            }
          ]
        }
        await this.action_removeCartProducts(requestObject);
      }
    } catch (error) {
      if(error.data && error.data.message) {
        this.$swal({
          title: "Error",
          text: "¡Ups! Hubo un error de nuestra parte. Por favor inténtalo de nuevo."
        })
      }
    }
    this.isLoading = false;
  }

  getMinusButtonLabel(item) {
    return this.isAbleToRemove(item) ? "-" : " ";
  }

  _onProductClick(item) {
    if(this.getCity && this.getCity.commercial_name && item.product_id) {
      this.$router.push({ name: 'productDetail', params: {
        city_id: cityParser(this.getCity.commercial_name),
        product_id: item.product_id
      }});
      this.OPEN_CART(false);
    }
  }

}
